export default {"src":"/_next/static/media/BIN.65830f0b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};